import { render } from "./TestResultStudent.vue?vue&type=template&id=f9a4d160&scoped=true"
import script from "./TestResultStudent.vue?vue&type=script&lang=js"
export * from "./TestResultStudent.vue?vue&type=script&lang=js"

import "./TestResultStudent.vue?vue&type=style&index=0&id=f9a4d160&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a4d160"]])

export default __exports__